export default __webpack_public_path__ + "static/media/bootstraplogo.d7b5af49.png";